module.exports = __webpack_public_path__ + "static/media/navy bean.509127e6.png";